import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { FormModel } from 'src_common/common/mobx-utils/Form2/FormModel';

export type FormHelperFormType = FormModel<{
    touchedForm: boolean;
}>;

export class FormHelper {
    private static touchedForm = FormInputState.new(false);

    public static get form(): FormHelperFormType {
        return FormModel.group({
            touchedForm: this.touchedForm,
        });
    }

    public static setIsTouched(form: FormHelperFormType): void {
        this.touchedForm.setValueOnChange(true);
        form.setIsTouched();
    }

    public static resetIsTouched(form: FormHelperFormType): void {
        this.touchedForm.setValueOnChange(false);
        form.resetIsTouched();
    }
}
